export default __webpack_public_path__ + "static/media/other.e8e09efb.gif";